import { useAuthStore } from "store/store"
import AdminMenu from "./AdminMenu";
import styled from "styled-components";
import AddProductForm from "./NewProductForm";
import { useState, useEffect } from "react";
import axios from "axios";
import FormatPrice from '../Helpers/FormatPrice'
import moment from "moment";

const statusColors = {
  Pending: "#856404",
  ProformaSend:"#9333ea",
  Processing: "#2563eb",
  Shipped: "#eab308",
  Email:"#0d9488",
  Delivered: "#155724",  
  Cancelled: "#dc2626",
};

//========================== To add a protected Route that only admins can access this page================

const AdminDashboard=()=>{
    const {auth}=useAuthStore();
    const [stats, setStats] = useState({
  totalUsers: 0,
  totalOrders: 0,
  totalProducts: 0,
  totalRevenue: 0
});

const [recentOrders, setRecentOrders] = useState([]);

useEffect(() => {
  const getDashboardStats = async () => {
    try {
      const { data } = await axios.get("/api/admin/dashboard", {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });

      if (data.success) {
         setStats({
        totalUsers: data.totalUsers,
        totalOrders: data.totalOrders,
        totalProducts: data.totalProducts,
        orderTotal: data.orderTotal // ✅ match backend key
  });

  if (data.orders) {
          const latestOrders = [...data.orders]
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .slice(0, 3);

          setRecentOrders(latestOrders);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (auth?.token) {
    getDashboardStats();
  }}, 
  [auth?.token]);

  

return(

  <Wrapper>
    <div className='grid grid-two-column'>
      <AdminMenu />
        <div className="content">
            {/* Welcome Section */}
          <div className="welcomeCard">
              <h2>Admin Dashboard 👨‍💼</h2>
              <p>Monitor platform performance and manage users & products.</p>
          </div>

            {/* Stats Section */}
          <div className="stats-grid">
            <div className="stat-card">
                <p>Total Users</p>
                <h3>{stats.totalUsers}</h3>
            </div>

            <div className="stat-card">
              <p>Total Orders</p>
              <h3>{stats.totalOrders}</h3>
            </div>

            <div className="stat-card">
              <p>Total Products</p>
              <h3>{stats.totalProducts}</h3>
            </div>

            <div className="stat-card">
             <p>Total Revenue</p>
             <h3><FormatPrice price={Math.round(stats.orderTotal)}/></h3>
            </div>
          </div>

            {/* Recent Orders */}
          <div className="orderCard">
            <h2>Recent Orders</h2>
              {recentOrders.length > 0 ? (
                 recentOrders.map((order, index) => (
                   <div
                        key={order._id}
                        className={`order-item ${
                          index === recentOrders.length - 1 ? "no-border" : ""
                        }`}
                      >
                      <div>
                       <p className="order-title">{order.orderNumber}</p>
                       <p className="order-date">
                         {moment(order.createdAt).format("DD MMM YYYY")}
                       </p>
                      </div>
             
                      <span className={`status ${order.status}`}>
                        {order.status}
                      </span>
                   </div>
                 ))
               ) : (
                 <p>No orders yet.</p>
               )}
             </div>
            
          </div>
        </div>
            
      </Wrapper>
    )
}
const Wrapper=styled.div`
.grid-two-column{
  grid-template-columns:2fr 8fr; 
  }
.content{
  padding: 1rem 7rem;
  }

.welcomeCard {
  background: white;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  margin-bottom: 24px;
  }

.welcomeCard h2 {
    font-size: 24px;
    margin-bottom: 8px;
    }

.welcomeCard p {
  color: #6b7280;
  }

.stats-grid {
  display: flex;                
  justify-content: space-between; 
  align-items: center;        
  margin-bottom: 24px;     
  }

.stat-card {
  display: flex;            
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: white;
  padding: 1.5 rem;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);       
  }

.stat-card p {
  color: #6b7280;
  margin-bottom: 8px;
  }

.stat-card h3 {
  font-size: 24px;
  font-weight: bold;
  color: #e70886;
  }
-----------------------
.orderCard {
  background: #fff;
  padding: 1.5rem;
  border-radius: 16px;
   box-shadow: 0 1px 6px rgba(0,0,0,0.8); 
  margin-bottom: 24px;
 }

.orderCard h2 {
  font-size: 22px;
  margin-bottom: 16px;
  color: #0e57f3;
  }

.order-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;

}

.no-border {
  border-bottom: none;
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  
  }

.order-title {
  font-weight: 500;
  }

.order-date {
  font-size: 14px;
  color: #6b7280;
  }

.status {
  font-weight: 500;
  font-size: 14px;
  }
.Pending {
  color: #f59e0b;
  }
.ProformaSend {
  color: #0bf1f5;
  }
.Processing {
  color: #10accb;
  }
.Shipped {
  color: #f5f50b;
  }
.Email {
  color: #28e7d3;
  }
.Delivered {
  color: #1ae264;
  }
.Cancelled {
  color: #dc2626;
  }

@media (max-width: ${({ theme }) => theme.media.mobile}) {
    
  .grid-two-column {
    grid-template-columns: 1fr; /* stack into one column */
  }
.content{
  padding: 1rem ;
  }

  .welcomeCard {
    padding: 1rem; /* reduce padding */  
     margin-bottom: 16px; 
   }

  .welcomeCard h2 {
    font-size: 20px; /* smaller heading */
  }

  .welcomeCard p {
    font-size: 15px; /* smaller text */
  }

  .stats-grid {
     flex-direction: row; 
    gap: 10px; 
    align-items: top;
  }

  .stat-card {
     padding: 10px; 
  }

  .stat-card h3 {
    font-size: 15px;
  }

  .orders-card {
    padding: 16px;
  }

  .orders-card h2 {
    font-size: 16px;
  }

  .order-item {
    align-items: flex-start;
  }

  .order-title {
   font-size: 14px;
  }

  .order-date, .status {
    font-size: 12px;
  } 
}
`;


export default AdminDashboard